import React, { useEffect, useState } from "react";
import CustomModalLayoutV2 from "../auctionFloor/components/CustomModalLayoutV2";
import { Button } from "../../../../shadcn/components/ui/button";
interface AuctionParticipationTncModelProps {
  onAgreeAndContinue: (eventId: string, eventStatus: string) => Promise<void>;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  eventId: string;
  eventStatus: string;
}

export default function AuctionParticipationTncModel({
  onAgreeAndContinue,
  isOpen,
  setIsOpen,
  eventId,
  eventStatus,
}: AuctionParticipationTncModelProps) {
  const [hasAgreed, setHasAgreed] = useState(false);
  const handleClose = () => {
    setIsOpen(false);
    setHasAgreed(false);
  };

  useEffect(() => {
    if (!isOpen) {
      setHasAgreed(false);
    }
  }, [isOpen]);

  const handleAgreeAndContinue = async () => {
    if (!hasAgreed) {
      console.error("User has not agreed to the terms and conditions");
      return;
    }
    await onAgreeAndContinue(eventId, eventStatus);
    setIsOpen(false);
    setHasAgreed(false);
  };

  return (
    <CustomModalLayoutV2
      open={isOpen}
      onClose={handleClose}
      blurBackground={true}
      className="!w-full mx-2 sm:mx-4 md:mx-6 max-w-[580px] max-h-[95vh] sm:max-h-[90vh] overflow-hidden"
      childrenClassName="py-4 px-0 overflow-hidden flex flex-col"
    >
      <div className="px-5 sm:px-6 pb-4">
        <h3 className="text-base sm:text-lg font-semibold text-brand-textBlack">
          Bid Participation Disclaimer
        </h3>
        <ul className="mt-3 list-disc pl-5 text-xs sm:text-sm text-brand-textBlack space-y-2">
          <li>
            Bid processing involves system validation and may take a few
            seconds.
          </li>
          <li>
            Bids placed very close to the auction end time may remain under
            processing when the auction concludes.
          </li>
          <li>
            Internet speed, device performance, and network latency are outside
            the control of AuctionBazaar.
          </li>
          <li>
            You are advised to place bids well before the auction end time.
          </li>
        </ul>

        <label className="mt-4 flex items-start gap-2 text-xs sm:text-sm text-brand-textBlack">
          <input
            type="checkbox"
            checked={hasAgreed}
            onChange={(event) => setHasAgreed(event.target.checked)}
            className="mt-1 h-4 w-4 text-brand-orange border-brand-orange rounded cursor-pointer"
          />
          <span>
            I have read and understood the above and agree to proceed.
          </span>
        </label>

        <div className="mt-5 flex items-center justify-end gap-3">
          <Button
            type="button"
            variant="outline"
            onClick={handleClose}
            className="h-8 px-4 text-xs sm:text-sm"
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleAgreeAndContinue}
            disabled={!hasAgreed}
            className="h-8 px-4 text-xs sm:text-sm bg-brand-orange text-white hover:bg-brand-orange"
          >
            I Agree &amp; Continue
          </Button>
        </div>
      </div>
    </CustomModalLayoutV2>
  );
}
